import { createStyles, makeStyles } from '../../styles';
export var useStyles = makeStyles(function () {
    return createStyles({
        paper: {
            boxShadow: 'none',
        },
    });
});
//# sourceMappingURL=ListboxDropdown.FloatingDropdown.styles.js.map